module.exports = __webpack_public_path__ + "static/media/overviewBgc.c1352a92.svg";